import LeadActivityEmptyState from './LeadActivityEmptyState.component';

export default LeadActivityEmptyState;
